$('.header_names').hover(
  function() {
        $(this).next('.child_list').show();

  }
  , function() {
        $(this).next('.child_list').hide();

  }

);

